import {useContext} from "react";
import LangContext from "../contexts/LangContext";

function UseTrans(name)   {
    const {trans, lang} = useContext(LangContext);

    if(!trans[name]) return name;
    return trans[name][lang];
}
export default UseTrans;